import React from "react";
import { FaLaptop, FaMobileAlt, FaTimesCircle } from "react-icons/fa";

const MobileBlocked: React.FC = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-lg w-full mx-4">
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
          {/* Header with icon */}
          <div className="bg-gradient-to-r from-red-500 to-red-600 px-8 py-6 text-center">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-white rounded-full mb-4">
              <FaMobileAlt className="text-red-500 text-4xl" />
              <FaTimesCircle className="text-red-500 text-2xl absolute -top-1 -right-1" />
            </div>
            <h1 className="text-3xl font-bold text-white mb-2">
              Mobile Access Restricted
            </h1>
          </div>

          {/* Content */}
          <div className="px-8 py-8">
            <div className="text-center mb-6">
              <p className="text-lg text-gray-700 mb-4 leading-relaxed">
                Your access on mobile is restricted. You are required to use
                this application on your <strong>office laptop only</strong>.
              </p>
            </div>

            {/* Info box */}
            <div className="bg-blue-50 border-l-4 border-blue-500 rounded-lg p-5 mb-6">
              <div className="flex items-start">
                <FaLaptop className="text-blue-500 text-2xl mr-3 mt-1 flex-shrink-0" />
                <div>
                  <h3 className="text-blue-800 font-semibold mb-2">
                    Please Use Your Office Laptop
                  </h3>
                  <p className="text-blue-700 text-sm leading-relaxed">
                    This application is designed to be accessed from your
                    company-issued laptop for security and compliance reasons.
                    Please switch to your office laptop to continue.
                  </p>
                </div>
              </div>
            </div>

            {/* Additional info */}
            <div className="bg-gray-50 rounded-lg p-5">
              <h4 className="text-sm font-semibold text-gray-700 mb-2">
                Why is this required?
              </h4>
              <ul className="text-sm text-gray-600 space-y-2 list-disc list-inside">
                <li>Security and compliance policies</li>
                <li>Optimal user experience on desktop</li>
                <li>Required system integrations</li>
              </ul>
            </div>
          </div>

          {/* Footer */}
          <div className="bg-gray-100 px-8 py-4 text-center">
            <p className="text-xs text-gray-500">
              If you believe this is an error, please contact your system
              administrator.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileBlocked;

